import React, { Component, useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { postData, getData, patchData, deleteData } from '../../util/Fetch';
import Button from '@mui/material/Button';
import swal from "sweetalert";
import ServiceModal from './ServiceModal';
import reactCSS from 'reactcss'

const Service = () => {
    const [rows, setRows] = React.useState([]);
    const [editData, setEditData] = React.useState(undefined);

    const styles = reactCSS({
        'default': {
          color: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
          },
          swatch: {
            padding: '5px',
            background: '#fff',
            borderRadius: '1px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
            display: 'inline-block',
            cursor: 'pointer',
          },
        },
      });

    useEffect(() => {
        getServices();
    }, []);

    
    const handleEditBtn = (rowData) => {
        setEditData(rowData);
    }

    const handleDeleteBtn = (event) => {
        var targetId = parseInt(event.target.id);
        deleteData('salonService', targetId).then(res => {
            if(res === true){
                setRows(rows.filter(x => x.serviceId != targetId));
                swal("刪除成功", "已成功刪除服務", "suceess");
            }
        })
    }

    const getServices = () => {
        getData('SalonService').then(res =>{
            setRows(res);
        });
    }

    return (
        <div>
            <ServiceModal getServices={getServices} editData={editData} setEditData={setEditData}/>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">排序號碼</TableCell>
                            <TableCell align="center">服務名稱</TableCell>
                            <TableCell align="center">預估時程</TableCell>
                            <TableCell align="center">價格上限</TableCell>
                            <TableCell align="center">價格下限</TableCell>
                            <TableCell align="center">顯示底色</TableCell>
                            <TableCell align="center">修改</TableCell>
                            <TableCell align="center">刪除</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {rows.map((row) => (
                        <TableRow
                        key={row.serviceId}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell align="center">{row.number}</TableCell>
                        <TableCell align="center">{row.serviceName}</TableCell>
                        <TableCell align="center">{row.timeConsuming}</TableCell>
                        <TableCell align="center">{row.priceLowerBound}</TableCell>
                        <TableCell align="center">{row.priceUpperBound}</TableCell>
                        <TableCell align="center"><div style={ styles.swatch }><div style={ {...styles.color, background: row.color} } /> </div></TableCell>
                        <TableCell align="center"><Button id={row.serviceId} variant="contained" onClick={() => handleEditBtn(row)}>修改</Button></TableCell>
                        <TableCell align="center"><Button id={row.serviceId} variant="contained" onClick={handleDeleteBtn}>刪除</Button></TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        
    );
}

export default Service
